import { Camera, Loader2 } from 'lucide-react';

export const DiscoverGallery = ({ tripInput, dynamicDestImages, destinationImages, destImagesLoading }) => (
  <div className="mb-8 bg-white/90 backdrop-blur-xl rounded-2xl shadow-2xl border border-white/30 p-8" data-testid="discover-gallery">
    <h3 className="font-serif text-xl text-ocean mb-4 flex items-center gap-2">
      <Camera className="w-5 h-5 text-gold" />
      Discover {tripInput.destination_city}
    </h3>
    <div className="grid grid-cols-4 gap-3 rounded-xl overflow-hidden">
      {(dynamicDestImages.length > 0 ? dynamicDestImages : destinationImages).map((img, idx) => (
        <div
          key={`dest-img-${idx}`}
          className={`relative overflow-hidden rounded-lg shadow-lg ${idx === 0 ? 'col-span-2 row-span-2' : ''}`}
        >
          {destImagesLoading && dynamicDestImages.length === 0 ? (
            <div className="w-full h-full aspect-square bg-sky/10 flex items-center justify-center">
              <Loader2 className="w-6 h-6 text-ocean/40 animate-spin" />
            </div>
          ) : (
            <img
              src={img}
              alt={`${tripInput.destination_city} view ${idx + 1}`}
              className="w-full h-full object-cover aspect-square hover:scale-110 transition-transform duration-500"
            />
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-ocean/30 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300" />
        </div>
      ))}
    </div>
  </div>
);
